/* eslint-disable */
// Ignore eslint rules for this file

// Stores
import { useAppDataStore } from '@/stores/appDataStore';
import { useUserDataStore } from '@/stores/userDataStore';

// Types
import { PaymentSummaryItem, FormType } from '@/types/user';
import { RoutePath, RouteName } from './routes';

// Utils
import { fetchPaymentSummary } from '@/api/apiCalls';
import routes from './routes';

// Vue
import {
  createRouter,
  createWebHistory,
  NavigationGuardNext,
  RouteLocationNormalizedGeneric,
} from 'vue-router';

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(
    to: RouteLocationNormalizedGeneric,
    from: RouteLocationNormalizedGeneric,
    savedPosition: any
  ) {
    // Always scroll to top
    return { top: 0 };

    // OR if you want to use saved position when using browser back/forward
    // return savedPosition || { top: 0 };
  },
});

// Navigation guard for authentication
router.beforeEach(
  async (
    to: RouteLocationNormalizedGeneric,
    from: RouteLocationNormalizedGeneric,
    next: NavigationGuardNext
  ) => {
    try {
      const appDataStore = useAppDataStore();
      const userDataStore = useUserDataStore();
      const token: string | null = userDataStore.getAuthToken;

      if (to.path === RoutePath.LOGIN && token !== null) {
        next(RoutePath.HOME);
        return;

      } else if (to.path === RoutePath.LOGIN) {
        next();
        return;

      } else {
        // Check if the route requires authentication
        const requiresAuth: boolean = to.matched.some((record) => record.meta.requiresAuth);
        const requiresGuest: boolean = to.matched.some((record) => record.meta.requiresGuest);

        const token: string | null = userDataStore.getAuthToken;

        // If route requires authentication and no token, redirect to login
        if (requiresAuth && !token) {
          next(RoutePath.LOGIN);
          return;
        }

        if (requiresAuth && token) {
          try {
            // Do things here that to happen after each route change
          } catch (error) {
            throw error;
          }
        }

        // Don't allow CHECKOUT route if the user has no balance due
        const hasUnpaidEntrants: boolean = Object.values(userDataStore.getPaymentSummary)
          .flatMap((item: PaymentSummaryItem[]) => item)
          .some((item: PaymentSummaryItem) => !item.paid);
        if (to.path === RoutePath.CHECKOUT && !hasUnpaidEntrants) {
          next(RoutePath.HOME);
          return;
        }

        // Don't allow PAYMENT_CONFIRMATION route if the user hasn't at least paid for the Primary Entrant
        if (to.path === RoutePath.PAYMENT_CONFIRMATION && !userDataStore.getCheckoutComplete) {
          next(RoutePath.HOME);
          return;
        }

        // Block Primary Entrant page if the Primary Entrant has already been paid for
        // NO LONGER NEEDED SINCE WE'RE NOW ALLOWING EDITING PRIMARY ENTRANT AFTER CHECKOUT
        // if (
        //   to.path.includes(RouteName.REGISTER_PRIMARY_ENTRANT) &&
        //   userDataStore.getPaymentSummary[FormType.PRIMARY_ENTRANT][0]?.paid
        // ) {
        //   next(RoutePath.HOME);
        //   return;
        // }

        // Block Co-Entrant page if the Co-Entrant has already been paid for
        if (
          to.path.includes(RouteName.REGISTER_CO_ENTRANT) &&
          userDataStore.getPaymentSummary[FormType.CO_ENTRANT][0]?.paid
        ) {
          next(RoutePath.HOME);
          return;
        }

        // Otherwise, proceed with the navigation
        next();
      }
    } catch (error) {
      console.error(`An error occurred in router.beforeEach: ${error}`);
      window.alert(`An error occurred in router.beforeEach: ${error}`);
    }
  }
);

export default router;
